/* eslint-disable react/display-name */
import React from 'react';

import { UserLayout } from '../UserLayout';
import { useUser } from 'hooks';

export const AdminLayout = ({ children, ...props }) => {
  const { isLoggedIn, isAdmin, redirectToDashboard } = useUser();

  React.useEffect(() => {
    if (!isLoggedIn) return;
    if (!isAdmin) {
      redirectToDashboard();
    }
  }, [isLoggedIn, isAdmin]);

  return isLoggedIn && isAdmin && <UserLayout {...props}>{children}</UserLayout>;
};

export const withAdminLayout = (Component) => (...props) => (
  <AdminLayout>
    <Component {...props} />
  </AdminLayout>
);
